module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bannerbg"
  }, [_c('img', {
    staticClass: "bannerbg_pic",
    attrs: {
      "src": _vm.src
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bannerbg_desc"
  }, [_c('div', {
    staticClass: "bannerbg_desc_title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "bannerbg_desc_entitle"
  }, [_vm._v(_vm._s(_vm.subtitle))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-990ed638","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainindex/BannerBg.vue
// module id = 1510
// module chunks = 0